import { useMemo } from "react";
import { useUserContext } from "src/context/config/userContext";
import { createClient } from "src/services/requestClient";

export default function useAuthorizationClient(apiRoot) {
  const { authorization } = useUserContext();

  const apiConfig = useMemo(() => {
    if (authorization)
      return {
        headers: {
          Authorization: authorization,
        },
      };
    else return null;
  }, [authorization]);

  return useMemo(() => {
    if (apiConfig && apiRoot) return createClient(apiRoot, apiConfig);
    return undefined;
  }, [apiConfig, apiRoot]);
}
